export const locale = {
  lang: 'fr-CA',
  data: {
    MATERIAL_COMBO_PANEL: {
      TITLE: "Modifier l'ensemble",
      TITLE_CREATE: 'Nouvel ensemble',
      LEFT_LIST_LABEL:
        'Glisser et déposer ou utiliser le bouton + pour ajouter du matériel',
      RIGHT_LIST_LABEL:
        "Réordonner, ajuster ou enlever un matériel de l'ensemble",
      CREATE_MATERIAL: 'Créer un matériel',
      SEARCH: 'recherche par nom interne, nom externe ou code de matériel',
      SEARCH_MATERIAL: 'Effectuez une recherche de votre matériel.',
      CATEGORY_FILTER: 'Catégorie de matériel',
      TAGS_FILTER: 'Tags',
      NO_SEARCH_RESULTS: 'Aucun résultat pour votre recherche.',
      NO_SEARCH_RESULTS_TRY_AGAIN: 'Veuillez essayer autre chose.',
      INTERNAL_VIEW_ONLY: 'Afficher à l’interne seulement',
      INTERNAL_VIEW_ONLY_SHORT: 'Interne',
      SHOW_UNIT_PRICE: 'Afficher le prix unitaire',
      SHOW_UNIT_PRICE_SHORT: 'Prix',
      REMOVE_ITEM: "Retirer de l'ensemble",
    },
  },
};
